import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmptyLayoutComponent } from './empty-layout.component';
import { RouterModule } from '@angular/router';
import { HeaderTopModule } from '../../common/components/header-top/header-top.module';
@NgModule({
  declarations: [
    EmptyLayoutComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    HeaderTopModule
  ],
  exports: [
    EmptyLayoutComponent
  ]
})
export class EmptyLayoutModule { }
